<app-shared-dialog
  [title]="'common.alerts' | translate"
  [options]="{
    cancelText: 'common.close' | translate,
    middleText: 'common.ignore_all' | translate,
    middleButtonStyle: 'secondary',
    confirmText: 'quotations_and_orders.remove_product' | translate,
    confirmButtonStyle: 'danger',
    size: 'large'
  }"
  (cancel)="close()"
  (middle)="ignoreAll()"
  (confirm)="removeProduct()"
>
  <div class="alerts-content">

    <!-- Product header -->
    <div class="product-header">
      <img
        class="product-img"
        [src]="data.product.image ? data.baseUrl + data.product.image + '?thumbnail=1' : placeholder"
        alt=""
      >
      <div class="product-info">
        <span class="product-name">{{ data.product.name }}</span>
        <span class="product-sku">{{ data.product | productCode }}</span>
      </div>
    </div>

    <!-- Active alerts -->
    <div class="alerts-section-label">{{ 'common.active' | translate }}</div>

    <div class="alert-list">
      <div
        *ngFor="let alert of activeAlerts"
        class="alert-item"
        [ngClass]="alert.level === 'alert' ? 'alert-item-danger' : 'alert-item-warning'"
      >
        <div class="alert-icon-wrap" [ngClass]="alert.level === 'danger' ? 'icon-danger' : 'icon-warning'">
          <app-svg-icon svgIcon="inventory"></app-svg-icon>
        </div>
        <span class="alert-message">{{ alert.message_key | translate }}</span>
        <div class="alert-actions">
          <button class="alert-action-btn ignore-btn" (click)="toggleAlert(alert.id)">
            {{ 'common.ignore' | translate }}
          </button>
          <ui-button
            type="secondary"
            [label]="'common.fix' | translate"
            (click)="fix()"
          ></ui-button>
        </div>
      </div>

      <div class="no-active-alerts" *ngIf="activeAlerts.length === 0">
        <span>{{ 'quotations_and_orders.no_active_alerts' | translate }}</span>
      </div>
    </div>

    <!-- Ignored section -->
    <div class="ignored-header" (click)="isIgnoredExpanded = !isIgnoredExpanded">
      <span class="ignored-label">
        {{ 'common.ignored' | translate }}
        <span class="ignored-count">{{ ignoredAlerts.length }}</span>
      </span>
      <ui-button type="secondary" icon="arrow" iconSize="medium" [rotated]="!isIgnoredExpanded"></ui-button>
    </div>

    <div class="alert-list" *ngIf="isIgnoredExpanded">
      <div *ngFor="let alert of ignoredAlerts" class="alert-item alert-item-ignored">
        <div class="alert-icon-wrap icon-ignored">
          <app-svg-icon svgIcon="inventory"></app-svg-icon>
        </div>
        <span class="alert-message">{{ alert.message_key | translate }}</span>
        <div class="alert-actions">
          <button class="alert-action-btn revert-btn" (click)="toggleAlert(alert.id)">
            {{ 'common.revert' | translate }}
          </button>
        </div>
      </div>
    </div>

  </div>
</app-shared-dialog>
